import { Button } from '@/components/ui';
import type { IHowToUseTip } from '@skystone/shared';

interface HowToUseTipsEditorProps {
  tips: IHowToUseTip[];
  onChange: (tips: IHowToUseTip[]) => void;
}

export function HowToUseTipsEditor({ tips, onChange }: Readonly<HowToUseTipsEditorProps>) {
  function handleTextChange(index: number, text: string) {
    const updated = tips.map((t, i) => (i === index ? { ...t, text } : t));
    onChange(updated);
  }

  function handleRemove(index: number) {
    const updated = tips
      .filter((_, i) => i !== index)
      .map((t, i) => ({ ...t, order: i + 1 }));
    onChange(updated);
  }

  function handleAdd() {
    onChange([...tips, { order: tips.length + 1, text: '' }]);
  }

  return (
    <div className="space-y-2">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        How to use this metric
      </p>
      {tips.map((tip, index) => (
        <div key={tip.order} className="flex items-start gap-2">
          <span className="mt-2 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-muted text-[10px] font-semibold text-muted-foreground">
            {index + 1}
          </span>
          <textarea
            className="flex-1 rounded-md border border-border bg-background px-2 py-1 text-xs leading-relaxed focus:border-primary focus:outline-none"
            rows={2}
            value={tip.text}
            onChange={(e) => handleTextChange(index, e.target.value)}
            aria-label={`Tip ${index + 1}`}
          />
          <Button
            variant="ghost"
            size="sm"
            onClick={() => handleRemove(index)}
            className="mt-1 text-xs text-muted-foreground hover:text-error"
            aria-label={`Remove tip ${index + 1}`}
          >
            Remove
          </Button>
        </div>
      ))}
      <Button variant="ghost" size="sm" onClick={handleAdd} className="text-xs">
        + Add tip
      </Button>
    </div>
  );
}
